// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

// Auth storage key constants
const AUTH_TOKEN_KEY = 'auth_token';
const AUTH_REMEMBER_KEY = 'auth_remember';

// Helper functions for auth management
export function isLoggedIn(): boolean {
  // Check if user is logged in (either in sessionStorage or localStorage with remember me)
  const sessionToken = sessionStorage.getItem(AUTH_TOKEN_KEY);
  const localToken = localStorage.getItem(AUTH_TOKEN_KEY);
  return !!(sessionToken || localToken);
}

export function setLoggedIn(rememberMe: boolean = false): void {
  const token = 'authenticated_' + Date.now();
  if (rememberMe) {
    // Save to localStorage for persistent login
    localStorage.setItem(AUTH_TOKEN_KEY, token);
    localStorage.setItem(AUTH_REMEMBER_KEY, 'true');
  } else {
    // Save to sessionStorage for session-only login
    sessionStorage.setItem(AUTH_TOKEN_KEY, token);
  }
}

export function clearAuth(): void {
  // Clear both storages to ensure complete logout
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_REMEMBER_KEY);
  sessionStorage.removeItem(AUTH_TOKEN_KEY);
}

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  // Check if user is logged in first
  if (!isLoggedIn()) {
    // User not logged in - throw error to trigger redirect to login
    return Promise.reject(new Error('User not logged in'));
  }
  
  // User is logged in - return admin user data
  return Promise.resolve({
    data: {
      name: 'NHACHINHCHU24H Admin',
      avatar: '/logo.png',
      userid: '00000001',
      email: 'admin@nhachinhchu24h.com',
      signature: 'NHACHINHCHU24H Administrator',
      title: 'Admin',
      group: 'NHACHINHCHU24H ADMIN SYSTEM',
      tags: [
        { key: '0', label: 'Admin' },
        { key: '1', label: 'Manager' },
      ],
      notifyCount: 0,
      unreadCount: 0,
      country: 'Vietnam',
      access: 'admin',
      geographic: {
        province: { label: 'Hà Nội', key: '110000' },
        city: { label: 'Hà Nội', key: '110100' },
      },
      address: 'Hà Nội, Vietnam',
      phone: '0123-456-789',
    },
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  // Clear auth storage on logout
  clearAuth();
  
  return Promise.resolve({
    data: {},
    success: true,
  });
}

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams & { autoLogin?: boolean }, options?: { [key: string]: any }) {
  // Hardcode credentials check - bypass database
  const HARDCODED_USERNAME = 'nhachinhchu_admin';
  const HARDCODED_PASSWORD = 'Nhachinhchu_admin@#1';
  
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));
  
  if (body.username === HARDCODED_USERNAME && body.password === HARDCODED_PASSWORD) {
    // Save auth state - use remember me (autoLogin) option
    setLoggedIn(body.autoLogin || false);
    
    return Promise.resolve({
      status: 'ok',
      type: body.type,
      currentAuthority: 'admin',
    });
  }
  
  // Return error for wrong credentials
  return Promise.resolve({
    status: 'error',
    type: body.type,
    currentAuthority: 'guest',
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}
